import * as React from 'react'
import { Box, BoxProps } from '@mui/material'
import { grey } from '@mui/material/colors'

interface ParticipantCardProps extends BoxProps {
  children: React.ReactNode
}

/**
 * This wrapper is used to add spacing bg-color and border radius
 * for participants profile cards.
 * @returns children wrapped in a ParticipantCard
 */

const ParticipantCard = ({ children, ...restProps }: ParticipantCardProps) => {
  return (
    <Box
      sx={{
        padding: 3,
        bgcolor: grey[50],
        borderRadius: {
          xs: 2,
          md: 3,
        },
      }}
      {...restProps}
    >
      {children}
    </Box>
  )
}

export default ParticipantCard
